import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import ServiceDayNotice from "components/ServiceDayNotice";
import * as React from "react";
import { Link, useLocation } from "react-router";
import { capitalizeWords } from "utils/display";

export default function RouterBreadcrumbs() {
  const { pathname } = useLocation();
  const pathnames = pathname.split("/").filter((x) => x);

  return (
    <Box
      sx={(theme) => ({
        p: 2,
        borderBottom: `1px solid ${theme.palette.gray.light}`,
        backgroundColor: theme.palette.white.main,
      })}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;

          return (
            index > 0 && (
              <Typography
                variant="subtitle1"
                key={to}
                component={Link}
                to={to}
                underline="hover"
                sx={{
                  color: "inherit",
                }}
              >
                {/\d/.test(value) ? value : capitalizeWords(value)}
              </Typography>
            )
          );
        })}
      </Breadcrumbs>
      <ServiceDayNotice />
    </Box>
  );
}
